const endpoints = {
  dev: {
    api: 'https://hotels.dev-ga.cloudbeds-dev.com/booking/',
    files: 'https://booking-engine.dev-ga.cloudbeds-dev.com',
  },
  stage: {
    api: 'https://hotels.stage-ga.cloudbeds-dev.com/booking/',
    files: 'https://booking-engine.stage-ga.cloudbeds-dev.com',
  },
  prod: {
    api: 'https://hotels.cloudbeds.com/booking/',
    files: 'https://booking-engine.cloudbeds.com',
  },
};

export const ORIGIN =
  process.env.NODE_ENV !== 'test'
    ? location.origin
    : 'https://hotels.acessa.loc';

export const IS_LOCAL_DEVELOPMENT = process.env.NODE_ENV === 'development';
export const env =
  IS_LOCAL_DEVELOPMENT || ORIGIN.includes('dev-ga')
    ? 'dev'
    : ORIGIN.includes('stage-ga')
    ? 'stage'
    : 'prod';

export const API = process.env.REACT_APP_API_BASE || endpoints[env].api;
export const FILES =
  process.env.REACT_APP_STATIC_FILES ||
  (IS_LOCAL_DEVELOPMENT ? ORIGIN : endpoints[env].files);
